import { createAction } from 'redux-actions'

const BLOCK_NAV = 'sc/app/BLOCK_NAV';

const initialState = {
  blockedNavigation: false
}

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case BLOCK_NAV:
      return {
        ...state,
        blockedNavigation: action.payload
      }
    default:
      return state;
  }
}

export const blockNavigation = createAction(BLOCK_NAV, () => true);
export const unblockNavigation = createAction(BLOCK_NAV, () => false);